import React, { useMemo, useState, useEffect,useContext } from 'react';
import { useNavigate, useLocation, useParams, Navigate } from "react-router-dom";
import axios from 'axios';
import { Calendar, Views, momentLocalizer } from 'react-big-calendar';
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../SessionPopup"
import Select from "react-select";
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
let { lambda, appname } = window.app
const localizer = momentLocalizer(moment);

 const bookedSlots = {
    '1AM': ['Premium', 'VIP'],
    '3PM': ['Premium', 'VIP'],
    '5PM': ['Free', 'VIP'],
    '8PM': ['Free'],
    '10PM': ['Premium']
  };

// Custom Toolbar Component to Hide Today, Back, Next Buttons
const CustomToolbar = () => <div />;

// Custom Header Component to Hide Date Headers
const CustomHeader = () => <div style={{ display: 'none' }} />;

const SpotsManage = () => {
  let { id } = useParams();
  const defaultDate = useMemo(() => new Date(2025, 2, 10), []);
  const {userData, setUserData} = useContext(contentContext)
  const [selectedDate, setSelectedDate] = useState(defaultDate);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [image, setImg] = useState('')
  const[showPopup,setShowPoup]=useState(false)
  const[showCalender,setShowcalender] =useState(false)
  const[isActive,setIsActive]=useState("regular")
  const[spotDay,setSpotDay]=useState('MONDAY')
  const [selectedDays, setSelectedDays] = useState(["Monday"]);
  const navigate = useNavigate();
  const [selectedSlots, setSelectedSlots] = useState([]); // Store added slots
  const daysOfWeek = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
  const [plansData,setPlansData]=useState([])
  const[spotsData,setSpotsData]=useState([])
  const[singleSpot,setSingleSpot]=useState({})
  const [formData, setFormData] = useState({
    // businessaddress: '',
    // name: '',
    // category: '',
    // phone: '',
    // logo: [],
    // storeImages: [],
    // idc: "USA(+1)",
    // maxVisitor: 0,
    // maxPartySize: 0,
    // codeExpiration: 0,
    // automatedExit: 0,
    // visitDuration: 0,
    // maxLocationCapacity: 0,
    // basicPlan: {},
    // premiumPlan: {},
    // vipPlan: {}


});

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const hours = Array.from({ length: 24 }, (_, index) => {
  const hour = index % 12 === 0 ? 12 : index % 12;
  const period = index < 12 ? 'AM' : 'PM';
  return `${hour}:00 ${period}`;
});
const [selectedDay, setSelectedDay] = useState('Monday');
const [timeSlots, setTimeSlots] = useState({
  starttime: '',
  endtime: ''
});

const handleDayChange = (e) => {
  setTimeSlots({
    ...timeSlots,
   
    starttime: '',
  endtime: ''
  });
   setSelectedDay(e.target.value)
   setSelectedDays([e.target.value])
};

const handleOpenTimeChange = (e) => {
  setTimeSlots({
    ...timeSlots,
   starttime: e.target.value,

  });

};
const isDisabled = (time) => {
  if (!selectedSlots || selectedSlots.length === 0) return false; // No restrictions if no slots are selected

  const currentIndex = hours.indexOf(time);
  if (currentIndex === -1) return false; // If time is not found, return false

  // Extract all selected start and end indexes, handling multi-day spans
  const selectedRanges = selectedSlots.map(slot => {
    const startIdx = hours.indexOf(slot.starttime);
    // let endIdx = hours.indexOf(slot.endtime.replace(/\s*\(Monday\)/, '')); // Remove (Monday) suffix
    let endIdx = hours.indexOf(slot.endtime.replace(/\s*\(\w+\)\s*/, '').trim());
    
    // If end time is earlier than start time, it spans into the next day
    const spansNextDay = endIdx <= startIdx;
   

    // If crossing to next day, extend endIdx by 24 hours to include the next day's slots
    if (spansNextDay) {
      endIdx += hours.length; // Extend end index into the next day
    }

    return { start: startIdx, end: endIdx, spansNextDay };
  }).filter(slot => slot.start !== -1 && slot.end !== -1);

  // Check if the selected time falls within any existing slot range
  return selectedRanges.some(({ start, end, spansNextDay }) => 
    (currentIndex >= start && currentIndex < end) ||  // Normal case (same day)
    // (spansNextDay && (currentIndex + hours.length >= start && currentIndex + hours.length <= end)) || // Next day wrap-around case
    (spansNextDay && currentIndex >= start) // Ensure end of Monday is also disabled
  );
};



const handleCloseTimeChange = (e) => {
 
  setTimeSlots(prevState => ({
    ...prevState,
    endtime: e.target.value, // Store the label including the day
  }));

};


// const generateClosingOptions = () => {
//   if (!timeSlots.openTime || !selectedDay) return [];

//   const currentDayIndex = days.indexOf(selectedDay);
//   const openIndex = hours.indexOf(timeSlots.openTime);
// console.log("openIndexxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",openIndex)
// console.log("timeSlotsssssssssssssssssssssssssssssssssssssssssssssssssssssssss",timeSlots.openTime)
//   const closingOptions = [];

//   // Generate options for the current day
//   for (let i = 0; i < hours.length; i++) {
//     closingOptions.push({
//       time: hours[i],
//       label: `${hours[i]} (${selectedDay})`,
//       disabled: i <= openIndex  // Disable times before and including open time
//     });
//   }

//   // Generate options for the next day (up to the same open time)
//   const nextDay = days[(currentDayIndex + 1) % days.length];
//   for (let i = 0; i < hours.length; i++) {
//     closingOptions.push({
//       time: hours[i],
//       label: `${hours[i]} (${nextDay})`,
//       disabled: i > openIndex  // Disable times after the open time of the previous day
//     });
//   }

//   return closingOptions;
// };

const hoursLabel = Array.from({ length: 24 }, (_, i) => {
  const hour = i % 12 || 12;
  const suffix = i < 12 ? "AM" : "PM";
  return `${hour < 10 ? "0" + hour : hour}${suffix}`;
});

// Group slots by hour
const groupedSlots = singleSpot?.[0]?.daySlotDetails?.[0]?.spots?.reduce((acc, slot) => {
  const hourKey = slot.spotstart.split(":")[0] + (slot.spotstart.includes("AM") ? "AM" : "PM");
  if (!acc[hourKey]) {
    acc[hourKey] = { hourLabel: slot.spotstart.split(" ")[1], slots: [] };
  }
  acc[hourKey].slots.push(slot);
  return acc;
}, {});

const generateClosingOptions = () => {
  if (!timeSlots.starttime || !selectedDay) return [];

  const currentDayIndex = days.indexOf(selectedDay);
  const openIndex = hours.indexOf(timeSlots.starttime);

  // Get all booked ranges based on selected slots
  const disabledRanges = selectedSlots.map(slot => {
    const startIdx = hours.indexOf(slot.starttime);
    const endIdx = hours.indexOf(slot.endtime);
    return { startIdx, endIdx };
  });

  console.log("Disabled Ranges:", disabledRanges);

  let closingOptions = [];

  // Check if selected start time is inside a booked slot
  const conflictingSlot = disabledRanges.find(({ startIdx, endIdx }) => openIndex >= startIdx && openIndex < endIdx);

  if (conflictingSlot) {
    // If start time is inside a booked slot, only allow closing before that range
    closingOptions = hours.map((time, i) => ({
      time,
      label: `${time} (${selectedDay})`,
      disabled: i >= conflictingSlot.startIdx && i <= conflictingSlot.endIdx, // Disable booked slot times
    }));
    console.log("Conflicttttttttttttttttttttttttttttt Closing Options:", closingOptions);
  } else {
    // Find the first blocked time in the next 24 hours
    let maxCloseIndex = openIndex + 24; // Default to 24-hour window
    for (let { startIdx } of disabledRanges) {
      if (startIdx > openIndex && startIdx < maxCloseIndex) {
        maxCloseIndex = startIdx; // Restrict closing to first booked time
      }
    }

    closingOptions = hours.map((time, i) => ({
      time,
      label: `${time} (${selectedDay})`,
      disabled: i === openIndex || i < openIndex || i > maxCloseIndex, // Disable before start & after allowed window
    }));

    // Enable closing up to maxCloseIndex only
    const nextDay = days[(currentDayIndex + 1) % days.length];
    // if (maxCloseIndex >= hours.length) {
      closingOptions.push(
        ...hours.map((time, i) => ({
          time,
          label: `${time} (${nextDay})`,
          disabled: i > maxCloseIndex - hours.length, // Disable times beyond maxCloseIndex
        }))
      );
    // }
    console.log("Final Closing Options:", closingOptions);
  }

  return closingOptions;
};




const closingOptions = generateClosingOptions();

const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
const useruniqueid = loginType === 'admin' ? localStorage.getItem("userId") : localStorage.getItem("clientid")
const [plans, setPlans] = useState([]);

const handleClose=()=>{
  setShowPoup(false)
}
const handleDayClick = (day) => {
  const formattedDay = day.trim().toUpperCase(); // Convert to uppercase for consistency

  const filteredSpots = spotsData.filter(
      (spot) => spot.spotday === formattedDay
  );

  setSingleSpot(filteredSpots);
  // console.log("Filtered Spots:", filteredSpots);
};

  const handleAddWork =()=>{
setShowPoup(true)
  }
console.log("selectedddddddddddddddd--------->",selectedDay)
 
  useEffect(()=>{
getStore()
  },[])
  useEffect(() => {
    console.log("Updated Selected Days:", selectedDays);
  }, [selectedDays]);
  useEffect(() => {
 
    if (window.site === undefined) {
        setTimeout(() => {
            if (window.site && window.site.common && window.site.common.imageCloudfront) {
                setImg(window.site.common.imageCloudfront)
            }
        }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
        setImg(window.site.common.imageCloudfront)
    }


   
}, [window.site]);


const handlePlanSdata=(e)=>{
console.log("e.target.value---------------------->",e.target.value)
}


  // Add the selected slot to the list
  const handleAddSlot = () => {
    if (!timeSlots.starttime || !timeSlots.endtime) {
        alert("Please select a valid time slot.");
        return;
    }

    setSelectedSlots((prevSlots) => {
        const updatedSlots = [...prevSlots, timeSlots];

        setPlans((prevPlans) => {
            if (prevSlots.length === 0) {
                // First slot: Modify only the first two default objects
                return prevPlans.map((plan, index) =>
                    index < 2 ? { ...plan, starttime: timeSlots.starttime, endtime: timeSlots.endtime } : plan
                );
            }

            // Subsequent slots: Create new objects for each base plan
            const basePlans = prevPlans.slice(0, 2); // First two objects are the base plans
            
            // Ensure the new slot is not already added
            const isSlotAlreadyAdded = prevPlans.some(
                plan => plan.starttime === timeSlots.starttime && plan.endtime === timeSlots.endtime
            );

            if (isSlotAlreadyAdded) return prevPlans; // Prevent duplicates

            const newSlotPlans = basePlans.map(plan => ({
                ...plan,
                starttime: timeSlots.starttime,
                endtime: timeSlots.endtime
            }));

            return [...prevPlans, ...newSlotPlans];
        });

        return updatedSlots;
    });

    setTimeSlots({ starttime: "", endtime: "" });
    setPlansData([]);
};






console.log("planssssssssssssssssssssssss",plans)
console.log("selectedSlotsssssssssssssssssssssssss",selectedSlots)

const handleDeleteSlot = (index) => {
  const updatedSlots = selectedSlots.filter((_, i) => i !== index);
  setSelectedSlots(updatedSlots);
};

const handleDaySelect = (day) => {
  setSelectedDays((prevDays) => {
    if (prevDays.includes(day)) {
      // If day exists, remove it
      return prevDays.filter((d) => d !== day);
    } else {
      // Otherwise, add it
      return [...prevDays, day];
    }
  });
};

  const handleCalender=()=>{
    // GetTimeActivity()   
// setBtnLoader(true)
  
const token = localStorage.getItem("token");
let payload = {};

// Cleaning `plans` to remove "(Monday)" from `endtime`
const cleanedPlans = plans.map(plan => ({
  ...plan,
  endtime: plan.endtime ? plan.endtime.replace(/\s*\(Monday\)/, '') : '' // Ensures `endtime` is valid
}));


// Cleaning `selectedSlots` to remove "(Monday)" from `closeTime`
const cleanSelectPlans = selectedSlots.map(slot => ({
  ...slot,
  endtime:slot.endtime? slot.endtime.replace(/\s*\(Monday\)/, ''):"" // Removes " (Monday)"
}));

// Constructing the payload
payload = {
  storeid: formData?.storeid,
  spotstype: "REGULAR",
  spotdaystartend: cleanSelectPlans,
  spotdayplanstartend: cleanedPlans,
  createdBy: {
    userId: userData?.clientid
  },
  days: selectedDays
};


          axios({
              method: 'POST',
              url: lambda + '/addSpots?appname=' + appname,
              data: payload,
          })
              .then(function (response) {
                  if (response) {
                      if (response?.result==="Invalid token or Expired") {
                          // setShowSessionPopupup(true)
                      }  else {
                        getSpots(formData?.storeid)
                        setSelectedSlots([])
                        setPlans([])
                        // setBtnLoader(false)
                        //   getSbscriptionsApi()
                        //   // setIsLoading(false);
                        //   // setUpdateSuccess(true)
                        //   setToastMessage("Plan Updated Successfully")
                      
                 
                   
                          // setToastType("success")
                          // GetClientDataContext()
                      }
                  }
  
              });
              setShowcalender(true)
              setShowPoup(false)
      // Add your save logic here.
  } 
   
  

  const handleChange = (selected) => {
    setSelectedOptions(selected);
  };

  const handleClick=(value)=>{
    setIsActive(value)
   }
  const handleEditHour =(Id)=>{
axios({
  method: 'GET',
  url: lambda + '/getSpots?appname=' + appname+"&storeid="+Id ,
})
  .then(function (response) {
      if (response?.data?.result==="Invalid token or Expired") {
          // setShowSessionPopupup(true)
      } else {
        const result=response?.data?.result?.[0]?.daySpots
        const filterSpotDay=result?.filter((day)=>day?.spotday===spotDay)

        setSpotsData(result)
        setSingleSpot(filterSpotDay)
        
              // setSubscriptionsData(response?.data?.result);
          // setSelectedPlan(response?.data?.result?.[0])
                // setEditedData([])
          
      }

  }).catch((err) => {
      console.log('error', err);
    
  });
  }
   const handleBack=()=>{
    navigate("/spots")
   }
   const getStore = (e) => {
    // GetTimeActivity()
    const token = localStorage.getItem("token")
    axios({
        method: 'POST',
        url: `${lambda}/getStores?appname=${appname}&userid=${useruniqueid}&storeid=${id}&token=${token}`,
        // + "&token=" + token,
    })
        .then(function (response) {
            if (response?.data?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true)
            } else {
                if (response?.data?.result) {
                    const result = response?.data?.result?.[0];
                    setFormData(result)
                    getSpots(result?.storeid)
                    
                    // setEditData((prevData) => ({
                    //     ...prevData,
                    //     maxVisitor: result?.maxVisitor ?? prevData?.maxVisitor,
                    //     maxPartySize: result?.maxPartySize ?? prevData?.maxPartySize,
                    //     codeExpiration: result?.codeExpiration ?? prevData?.codeExpiration,
                    //     automatedExit: result?.automatedExit ?? prevData?.automatedExit,
                    //     visitDuration: result?.visitDuration ?? prevData?.visitDuration,
                    //     maxLocationCapacity: result?.maxLocationCapacity ?? prevData?.maxLocationCapacity,
                    // }));

                    // setEditData(result?.maxVisitor,result?.maxPartySize,result?.codeExpiration,result?.automatedExit,result?.visitDuration,result?.maxLocationCapacity,)
                    if (result?.preferences) {
                      const activePlans = Object.values(result.preferences).filter(plan => plan.active); // Extract only active plans
                  
                      const formattedPlans = activePlans.map(plan => ({
                          // starttime: plan.starttime || "10:00", // Default value or from API
                          // endtime: plan.endtime || "12:00", // Default value or from API
                          plan: plan.name || "Unknown", // Plan name
                          // maxvisitors: plan.maxvisitors || 10, // Default or API value
                          price: Number(plan.price) || 0,
                          maxvisitors: Number(1) || 0, // Default or API value
                      }));
                    
                      setPlans(formattedPlans);
              
                    }
                  
                    // setIdc(response?.data?.result?.[0]?.idc)
                    // setMapAddress({
                    //     businessaddress: result?.businessaddress || "",
                    //     latitude: result?.latitude || "",
                    //     longitude: result?.longitude || ""
                    // })
                    // let siteConfig = window?.site?.common;
                    // let appResourcesUrl = siteConfig?.imageCloudfront;
                    // let logoPath = appResourcesUrl + result?.logo?.[0].filepath
                    //  console.log("image",logoPath)
                    // setUploadImg(logoPath)

                } else {
                    // setInvalidContent(true)
                }

            }

            // setDisableSaveBtn(false)
        });
}
const getSpots = (Id) => {
  axios({
      method: 'GET',
      url: lambda + '/getSpots?appname=' + appname+"&storeid="+Id ,
  })
      .then(function (response) {
          if (response?.data?.result==="Invalid token or Expired") {
              // setShowSessionPopupup(true)
          } else {
            const result=response?.data?.result?.[0]?.daySpots
            const filterSpotDay=result?.filter((day)=>day?.spotday===spotDay)
       console.log("filterSpotDay---->",filterSpotDay)
            setSpotsData(result)
            setSingleSpot(filterSpotDay)
            
          
              // setSubscriptionsData(response?.data?.result);
              // setSelectedPlan(response?.data?.result?.[0])
                    // setEditedData([])
              
          }

      }).catch((err) => {
          console.log('error', err);
        
      });
}

  return (
    // <div>
     
    //   <div className="flex gap-2 mb-4">
    //     {daysOfWeek.map(day => (
    //       <button
    //         key={day}
    //         onClick={() => handleDayClick(day)}
    //         className={`px-4 py-2 rounded ${selectedDay === day ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
    //       >
    //         {day}
    //       </button>
    //     ))}
    //   </div>

    
    //   <div className="height600 mb-4">
    //     <Calendar
    //       date={selectedDate}
    //       defaultView={Views.DAY}
    //       views={['day']}
    //       events={filteredEvents}
    //       localizer={localizer}
    //       step={15}
    //       timeslots={8}
    //       toolbar={false}
    //       components={{
    //         toolbar: CustomToolbar,
    //         day: { header: CustomHeader }
    //       }}
    //     />
    //   </div>

    
    //   {filteredEvents.length > 0 ? (
    //     <div>
    //       <h2 className="text-xl font-bold mb-2">{selectedDay} - Events</h2>
    //       <ul>
    //         {filteredEvents.map(event => (
    //           <li key={event.title} className="mb-1">
    //             {event.title} - {moment(event.start).format('hh:mm A')} to {moment(event.end).format('hh:mm A')}
    //           </li>
    //         ))}
    //       </ul>
    //     </div>
    //   ) : (
    //     <p>No events for {selectedDay}</p>
    //   )}

    //   <div className="mt-4">
    //     <h3 className="text-lg font-bold">Selected Date: {moment(selectedDate).format('MMMM Do YYYY')}</h3>
    //   </div>
    // </div>
    <>
    {showSessionPopupup && <SessionPopup />}
    <div id="layout-wrapper">
        <Header />
        <Sidebar />

        {/* Start right Content here  */}
      
<div className="main-content user-management spots">

<div className="page-content">
<div className="container-fluid">



 <div className="row  breadcrumb">
     <div className="col-lg-12">
         <div className="d-flex align-items-center">

             <div className="flex-grow-1">
                 <h4 className="mb-2 card-title">Spots</h4>

             </div>
             {/* {subValDashboard && subValDashboard.Add && subValDashboard.Add.display === true && */}
                 <div>
                     <button className="fill-btn-style" 
                     onClick={handleBack} 
                    //  disabled={subValDashboard && subValDashboard.Add && subValDashboard.Add.enable === false}
                     >Back</button>
                 </div>
                 {/* } */}
         </div>
     </div>
 </div>

<div className="row manage-hours">
<div className="col-12 Add-store-block">
<div className="card">
<div className="card-body d-flex align-items-center">
<h4 className="form-title mb-0" id="location-info-title">SELECT STORE</h4>
<div class="input-group">

<select id="country-code" name="idc" value={formData?.name} className="multi-select-style">

                                           <option value={formData?.name}>{formData?.name}</option>
                                            </select>
</div>
{/* <button class="fill-btn save_continue">ADD</button> */}
</div>
</div>
</div>
</div>

 <div className="row table-data">
     <div className="col-12">
         <div className="card">
             <div className="card-body">
            <ul className="nav nav-tabs nav-tabs-custom" role="tablist" id="tab-navigation">
                <li className="nav-item" role="presentation" id="tab-regular-hours" style={{ cursor: "pointer" }} onClick={()=>handleClick("regular")}>
                    <a  className={`nav-link ${isActive === "regular" ? "active" : ""}`} >
                        <span className="material-symbols-outlined">schedule</span>
                        <span className="d-none d-sm-block">REGULAR HOURS</span>
                    </a>
                </li>

                <li className="nav-item" role="presentation" id="tab-special-hours" style={{ cursor: "pointer" }} onClick={()=>handleClick("special")}>
                <a className={`nav-link ${isActive === "special" ? "active" : ""}`}>
                        <span className="material-symbols-outlined">kid_star</span>
                        <span className="d-none d-sm-block">SPECIAL HOURS</span>
                    </a>
                </li>
</ul>
{/* spots tab start */}



{/* spots tab Start */}
<div className="tab-content p-3 text-muted">

{/* REGULAR HOURS TAB */}
<div className={`tab-pane ${isActive === "regular" ? "active show" : ""} weekly-section`}
            id="home1" role="tabpanel">
            
{/* Weekend tab start */}
{/* <ul className="nav nav-pills weekly-wrapper" id="pills-tab" role="tablist">
  {daysOfWeek.map(day => (
    <li className="nav-item" role="presentation" key={day}>
      <button
        onClick={() => handleDayClick(day)}
        className={`nav-link week-btn ${selectedDay === day ? 'active' : ''}`}
        id={`pills-${day}-tab`}
        data-bs-toggle="pill"
        data-bs-target={`#Week-${day}`}
        type="button"
        role="tab"
        aria-controls={`Week-${day}`}
        aria-selected={selectedDay === day}
      >
        {day}
      </button>
    </li>
  ))}
</ul> */}


{/* Weekend Monday */}

{spotsData?.length>0?
<>
  <ul class="nav nav-pills weekly-wrapper" id="pills-tab" role="tablist">
  {daysOfWeek.map(day => (
    <li className="nav-item" role="presentation" key={day}>
      <button
        onClick={() => handleDayClick(day)}
        className={`nav-link week-btn ${spotDay === day ? 'active' : ''}`}
        id={`pills-${day}-tab`}
        data-bs-toggle="pill"
        data-bs-target={`#Week-${day}`}
        type="button"
        role="tab"
        // aria-controls={`Week-${day}`}
        // aria-selected={selectedDay === day}
      >
        {day}
      </button>
    </li>
  ))}
</ul>
{singleSpot?.length>0?<div class="tab-pane fade show active" id="Week-Mon" role="tabpanel" aria-labelledby="Week-Mon">
<div className="row store">
                            <div className="col-md-3">
                            {/* left side store pannel */}
                            <div className="store-panel-left">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h4 className="form-title mb-0" id="location-info-title">STORE WORKING HOURS</h4>
                                        <div className="input-field switch-buttons d-flex align-items-center">
                                        <label className="col-form-label p-0 me-2">Store Open</label>
                                        <label className="switch disable mb-0"><input type="checkbox"/>
                                        <span className="slider round"></span>
                                        </label>
                                        </div>
                                    </div>
                                    {singleSpot?.[0]?.spotdaystartend?.map((item, index) => (
  <button 
    key={index} 
    className="time-fill-btn w-100 mt-4 d-flex align-items-center justify-content-center"
  >
    <span className="material-symbols-outlined me-2">schedule</span> 
    {`${item?.starttime} ${(singleSpot?.[0]?.spotday?.slice(0,3))} to ${item?.endtime} ${(singleSpot?.[0]?.spotday?.slice(0,3))}`}
  </button>
))}

                                {/* <button className="outline_btn w-100 mt-4 d-flex align-items-center justify-content-center"><span className="material-symbols-outlined me-2">add_circle</span> Add Working Hours</button> */}
                               
                                {/* <button className="time-fill-btn w-100 mt-3 d-flex align-items-center justify-content-center"><span className="material-symbols-outlined me-2">schedule</span> 03:00 PM (mon) to 03:00 AM (Tue)</button> */}
                                <button className="outline_btn d-flex align-items-center justify-content-center mt-4" onClick={()=>handleEditHour(singleSpot?.[0].storeid)}><span className="material-symbols-outlined me-2">edit_calendar</span>Edit Hours</button>
                                {/* <p className="sm-heading text-center mt-3">Add Stores To Get Started</p> */}
                                </div>
                            </div>

                            {/* right side store pannel */}
                            <div className="col-md-9 ps-1">
                            <div className="store-panel-right">
                            {/* <div className="text-center">
                            <img src="./assets/img/Spots-graphic.svg" alt="Calendar" className="img-fluid" style={{ maxWidth: "300px" }} />
                            <h5 className="form-title mt-3">No Spots Set Yet!</h5>
                            <p className="tsm-heading">Add Stores To Get Started</p>
                            </div> */}
<div style={{ height: 500 }} className="calander-block">
<h4 class="form-title mb-0">PAID PLANS</h4>
<table className="table calander-grid mt-4">
  <thead>

  <tr>
      <td className="timming-row day-show">W3</td>
      <td colspan="4" className="text-center day-show">MONDAY</td>
    </tr>

    <tr>
      <td className="timming-row time-display">all-day</td>
      <td className="timming-slot-section"></td>
      <td className="timming-slot-section"></td>
      <td className="timming-slot-section"></td>
      <td className="timming-slot-section"></td>
    </tr>
  </thead>

  <tbody>
  {/* here slots */}


  {hoursLabel.map((hourKey) => {
        const hourData = groupedSlots[hourKey] || { slots: [] };

        return (
          <tr key={hourKey}>
            <td className="time-display">{hourKey}</td>
            {hourData.slots.map((slot) => (
              <td key={slot.spotid}>
                <button className="timming_slot">
                  <span>{slot.spotstart}</span>
                  <span>
      {slot.plans.includes("Basic") && (
        <img src={`${image}${appname}/images/web/Free-Badge.svg`} alt="Free Badge" />
      )}
      {slot.plans.includes("Premium") && (
        <img src={`${image}${appname}/images/web/Premium-Badge.svg`} alt="Premium Badge" />
      )}
      {slot.plans.includes("VIP") && (
        <img src={`${image}${appname}/images/web/VIP-Badge.svg`} alt="VIP Badge" />
      )}
    </span>
                </button>
              </td>
            ))}
            {hourData.slots.length < 4 &&
              Array(4 - hourData.slots.length)
                .fill()
                .map((_, i) => <td key={`empty-${i}-${hourKey}`}></td>)}
          </tr>
        );
      })}
    {/* <tr>
      <td className="time-display">09am</td>
      <td>
        <button className="timming_slot">
            <span>09:00 AM</span>
            <span>
            <img src={`${image}${appname}/images/web/Free-Badge.svg`} alt="Free Badge" />
            <img src={`${image}${appname}/images/web/Premium-Badge.svg`} alt="Premium Badge" />
            <img  src={`${image}${appname}/images/web/VIP-Badge.svg`}  alt="VIP Badge" />
            </span>
        </button>
      </td>
      <td>
      <button className="timming_slot">
            <span>09:10 AM</span>
            <span>
            <img src={`${image}${appname}/images/web/Free-Badge.svg`} alt="Free Badge" />
            <img src={`${image}${appname}/images/web/Premium-Badge.svg`} alt="Premium Badge" />
            <img  src={`${image}${appname}/images/web/VIP-Badge.svg`}  alt="VIP Badge" />
            </span>
        </button>
      </td>
      <td>
      <button className="timming_slot">
            <span>09:30 AM</span>
            <span>
            <img src={`${image}${appname}/images/web/Free-Badge.svg`} alt="Free Badge" />
            <img src={`${image}${appname}/images/web/Premium-Badge.svg`} alt="Premium Badge" />
            <img  src={`${image}${appname}/images/web/VIP-Badge.svg`}  alt="VIP Badge" />
            </span>
        </button>
      </td>
      <td>
        <button className="timming_slot">
            <span>09:45 AM</span>
            <span>
            <img src={`${image}${appname}/images/web/Free-Badge.svg`} alt="Free Badge" />
            <img src={`${image}${appname}/images/web/Premium-Badge.svg`} alt="Premium Badge" />
            <img  src={`${image}${appname}/images/web/VIP-Badge.svg`}  alt="VIP Badge" />
            </span>
        </button>
      </td>
    </tr> */}

   
    
  </tbody>
</table>                    
</div>
                            </div>
                            </div>

</div>
</div>:<div className="container text-center">
    <div className="image-container">
        <img
            src={`${image}${appname}/images/web/Store-Closed.svg`}
            alt="No spots available"
            className="img-fluid"
            style={{ maxWidth: "300px" }}
        />
    </div>
    <h5 className="mt-3 fw-bold">Store is Closed tody</h5>
    <p className="text-muted">Check Store Open To Open Store Today </p>
    <button className="stroke-button"
                                id="add-store-button"
                                onClick={handleAddWork}
                                style={{ display: "inline-flex" }}
                            >
                              <span class="material-symbols-outlined">add_circle</span>ADD WORKING HOURS
                            </button>
</div>}
{/* Weekend Monday */}



</>:<div className="container text-center">
    <div className="image-container">
        <img
            src={`${image}${appname}/images/landingPage/spots-default-img.svg`}
            alt="No spots available"
            className="img-fluid"
            style={{ maxWidth: "300px" }}
        />
    </div>
    <h5 className="mt-3 fw-bold">No Spots Set Yet!</h5>
    <p className="text-muted">Add stores to get started</p>
   <>
      <button className="stroke-button"
                                id="add-store-button"
                                onClick={handleAddWork}
                                style={{ display: "inline-flex" }}
                            >
                              <span class="material-symbols-outlined">add_circle</span>ADD WORKING HOURS
                            </button>
    </>
    
</div>}


</div> 


{/* SPECIAL HOURS TAB */}
<div className={`tab-pane ${isActive === "special" ? "active show" : ""}`}
            id="home1" role="tabpanel">


<div className="container text-center">
    <div className="image-container">
        <img
            src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/landingPage/spots-default-img.svg"
            alt="No spots available"
            className="img-fluid"
            style={{ maxWidth: "300px" }}
        />
    </div>
    <h5 className="mt-3 fw-bold">No Spots Set Yet!</h5>
    <p className="text-muted">Add stores to get started</p>
  
      <button className="fill-btn-style"
                                id="add-store-button"
                                // onClick={handleAddWork}
                                style={{ display: "inline-flex" }}
                            >
                              <span class="material-symbols-outlined">add_circle</span>ADD
                            </button>
   
    
</div>

</div> 
          
</div>
{/* spots tab Stop */}

</div>
<Modal className="add_hours" show={showPopup} >
             <div className="modal-header">
             <div className="add_hours_title">
             <div className="modal-title h4">ADD HOURS</div>
             <div className="max_visitor">
             <div className="max_visitor_status">{`Max Visitors ${formData?.maxVisitor}`}</div><div className="max_visitor_status">{`Max Party size ${formData?.maxPartySize}`}</div><div className="max_visitor_status">{`Max Capacity ${formData?.maxLocationCapacity}`}</div>
             </div>
             </div>
             <button type="button" class="close-btn"><span className="material-icons" onClick={handleClose}>close</span></button>
             </div>

<div className="modal-body">
<div className="working_hours premium_hours">
<h6>SET STORE WORKING HOURS</h6>

</div>
<div className="table-responsive">
<table className="table align-middle">
<thead>
    <tr>
    <th width="30%">
            <div className="form-group">
              <label className="form_label">Select Day</label>
              <select
                className="form-select"
                value={selectedDay}
                onChange={handleDayChange}
              >
                <option value="" disabled>Select Day</option>
                {days.map((day) => (
                  <option key={day} value={day}>{day}</option>
                ))}
              </select>
            </div>
          </th>

          <th width="30%">
            <div className="form-group">
              <label className="form_label">Opens</label>
              <select
                className="form-select"
                value={timeSlots.starttime}
                onChange={handleOpenTimeChange}
                disabled={!selectedDay}
              >
                <option value="" >opens</option>
                {hours.map((time) => (
                  <option key={time} value={time} disabled={isDisabled(time)}>{time} ({selectedDay})</option>
                ))}
              </select>
            </div>
          </th>

          <th width="30%">
            <div className="form-group">
              <label className="form_label">Close</label>
              <select
  className="form-select"
  value={timeSlots.endtime}

  onChange={handleCloseTimeChange}
  disabled={!timeSlots.starttime}
>
  <option value="" disabled>close</option>
  
  {closingOptions.map(({ time, label, disabled }, index) => (
    <option key={`${time}-${index}`} value={label} disabled={disabled}>
      {label}
    </option>
  ))}
</select>

            </div>
          </th>
        <th width="10%" className="right"><button className="fill-btn-style " id="save-button" onClick={handleAddSlot}><span className="material-symbols-outlined">add_circle</span>add</button></th>
        
        </tr>
        </thead>
        <tbody>
        {selectedSlots.map((slot, index) => (
            <tr key={index}>
              <td>{slot.starttime} ({selectedDay})</td>
              <td>{slot.endtime} </td>
              <td className="right">
                        <span className="material-symbols-outlined">edit</span>
                      </td>
              <td className="right">
                <span className="material-symbols-outlined" onClick={() => handleDeleteSlot(index)} style={{ cursor: "pointer" }}>
                  delete
                </span>
              </td>
            </tr>
             ))}
                    </tbody>
                    </table>
                    </div>
                    {formData?.preferences &&
  Object.keys(formData.preferences).map((key) => {
    const item = formData.preferences[key];

    return item?.active && (
      <>
        <div className="working_hours premium_hours">
          <h6>
            {item?.name === "Basic" ? "BASIC HOURS" :
             item?.name === "Premium" ? "PREMIUM HOURS" :
             item?.name === "VIP" ? "VIP HOURS" : ""}
          </h6>
        </div>

        <div className="table-responsive">
          <table className="table align-middle">
            <thead>
              <tr>
                <th width="25%">
                  <div className="form-group">
                    <label className="form_label">Opens</label>
                    <select className="form-select" name="open">
                    <option value="" >opens</option>
                {hours.map((time) => (
                  <option key={time} value={time} disabled={isDisabled(time)}>{time} ({selectedDay})</option>
                ))}
                    </select>
                  </div>
                </th>
                <th width="25%">
                  <div className="form-group">
                    <label className="form_label">Close</label>
                    <select className="form-select" name="open">
                    <option value="" disabled>close</option>
  
  {closingOptions.map(({ time, label, disabled }, index) => (
    <option key={`${time}-${index}`} value={label} disabled={disabled}>
      {label}
    </option>
  ))}
                    </select>
                  </div>
                </th>
                <th width="20%">
                  <div className="form-group">
                    <label className="form_label">Max Visitors</label>
                    <input className="form-control" placeholder="Enter" type="text" defaultValue="" onChange={handlePlanSdata}/>
                  </div>
                </th>
                <th width="20%">
                  <div className="form-group">
                    <label className="form_label">Price/ Spot</label>
                    <input className="form-control" placeholder="00.00" type="text" defaultValue="" />
                  </div>
                </th>
                <th width="10%" className="right">
                  <button className="fill-btn-style">
                    <span className="material-symbols-outlined">add_circle</span>add
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              {plans?.filter(plan => plan?.plan === item?.name)
                .map((plan, index) => 
                  plan?.starttime && plan?.endtime && (
                    <tr key={index}>
                      <td>{`${plan.starttime} ${selectedDay}`}</td>
                      <td>{`${plan.endtime}`}</td>
                      <td>20</td>
                      <td>{`$ ${plan.price}.00`}</td>
                      <td className="right">
                        <span className="material-symbols-outlined">edit</span>
                      </td>
                      <td className="right">
                        <span className="material-symbols-outlined">delete</span>
                      </td>

                    </tr>
                  )
              )}
            </tbody>
          </table>
        </div>
      </>
    );
  })
}




                   
</div>
<div className="modal-footer">
<div className="following_days">
<p>Apply the above settings to the following days</p>
<div className="check_buttons">
{days
  .filter((day) => day !== selectedDay) // Exclude the currently selected day
  .map((day) => (
    <div 
      key={day} 
      className={`check_button ${selectedDays.includes(day) ? "active" : ""}`} 
      onClick={() => handleDaySelect(day)}
    >
      {day.slice(0, 3).toUpperCase()}
    </div>
  ))}


</div>
</div>
<button className="fill-btn-style " id="save-button" onClick={handleCalender}>add</button>
</div>
</Modal>
             </div>
         </div>
     </div>
 </div>


</div>
</div>


    </div>
</>
  );
};

export default SpotsManage;
